// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AddressController from "./address_controller"
application.register("address", AddressController)

import AutoclickController from "./autoclick_controller"
application.register("autoclick", AutoclickController)

import FilterFormController from "./filter_form_controller"
application.register("filter-form", FilterFormController)

import FormController from "./form_controller"
application.register("form", FormController)

import RangeSliderController from "./range_slider_controller"
application.register("range-slider", RangeSliderController)

import RoundDecimalInputController from "./round_decimal_input_controller"
application.register("round-decimal-input", RoundDecimalInputController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import TrixController from "./trix_controller"
application.register("trix", TrixController)

// The build's --alias:@hotwired/stimulus=@hotwired/stimulus is load-bearing: it lets esbuild resolve these out-of-tree gem controllers' bare "@hotwired/stimulus" import.

import ClipboardController from "jet_ui/clipboard_controller"
application.register("clipboard", ClipboardController)

import DialogController from "jet_ui/dialog_controller"
application.register("dialog", DialogController)

import DialogsController from "jet_ui/dialogs_controller"
application.register("dialogs", DialogsController)

import DropdownController from "jet_ui/dropdown_controller"
application.register("dropdown", DropdownController)

import FlashController from "jet_ui/flash_controller"
application.register("flash", FlashController)

import PopoverController from "jet_ui/popover_controller"
application.register("popover", PopoverController)

import TooltipController from "jet_ui/tooltip_controller"
application.register("tooltip", TooltipController)

import TurboConfirmController from "jet_ui/turbo_confirm_controller"
application.register("turbo-confirm", TurboConfirmController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)
